export function isMacOS(): boolean {
  // Check for macOS in userAgent
  return /Mac/.test(navigator.userAgent);
}
